import { render } from "./FlexMessageTemplateEditModal.vue?vue&type=template&id=7b1b6200&scoped=true"
import script from "./FlexMessageTemplateEditModal.vue?vue&type=script&lang=ts"
export * from "./FlexMessageTemplateEditModal.vue?vue&type=script&lang=ts"

import "./FlexMessageTemplateEditModal.vue?vue&type=style&index=0&id=7b1b6200&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7b1b6200"

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QToolbar,QCardSection,QToolbarTitle,QBtn,QSpace});
